import React from "react";
import { object, number } from "prop-types";

import StoryElements from "../story-elements";
import StorySideBar from "../story-sidebar";
import VideoHeaderBlock from "./video-header-block";
import { AdContainer } from "../../ads";

import "./video.m.css";
import StorySeparator from "../../atoms/story-separator";

const getPrimaryVideo = (cards) => {
  const headerVideo = [];
  cards.forEach((card) => {
    card["story-elements"].forEach((element) => {
      if (element.type === "youtube-video" || element.subtype === "dailymotion-video") {
        headerVideo.push(element);
      }
    });
  });
  return headerVideo[0];
};

const getCards = (cards, id) => {
  let storyCards = [];
  cards.forEach((card) => {
    const newCard = Object.assign({}, card);
    let elements = [];
    card["story-elements"].map((element) => {
      if (element.id !== id) {
        elements = [...elements, element];
      }
    });
    newCard["story-elements"] = elements;
    storyCards = [...storyCards, newCard];
  });
  return storyCards;
};

const VideoStory = ({ story, index }) => {
  let primaryVideo = null;
  let cards = story.cards;

  const isReview = story["story-template"] === "review";

  if (!isReview) {
    primaryVideo = getPrimaryVideo(story.cards);
    cards = primaryVideo ? getCards(story.cards, primaryVideo.id) : story.cards;
  }

  return (
    <>
      {index > 0 && <StorySeparator />}
      <div styleName="story-wrapper">
        <div styleName="ad-wrapper" className="hide-desktop">
          <AdContainer AdClassName="standard-336x280" id="div-gpt-ad-1675837489260-0" mobile="PV_MWeb_AP_Top" />
        </div>
        <div className="story-section">
          <div>
            <VideoHeaderBlock story={story} primaryVideo={primaryVideo} isReview={isReview} index={index} />
            <StoryElements story={story} cards={cards} index={index} />
          </div>
        </div>
        <div className="side-story-section">
          <StorySideBar index={index} story={story} />
        </div>
        {/* <div className="more-news-section">
          <MoreNews story={story} />
        </div> */}
      </div>
    </>
  );
};

VideoStory.propTypes = {
  story: object,
  index: number
};

export default VideoStory;
